import React from "react";
import Seo, { faqSchema } from "../components/site/Seo";
import Breadcrumbs from "../components/site/Breadcrumbs";
import PageHero from "../components/site/PageHero";
import FaqSection from "../components/site/FaqSection";
import FinalCTA from "../components/site/FinalCTA";
import { GENERAL_FAQS } from "../lib/faqs";
import { IMG } from "../lib/site";

const FAQ = () => (
  <div>
    <Seo
      title="FAQ | Garage Floor Coating Questions | PRYME EPOXY"
      description="Answers to common questions about epoxy and polyaspartic garage floors, warranties, install time, and more from PRYME EPOXY in Northern Arizona."
      path="/faq"
      jsonLd={faqSchema(GENERAL_FAQS)}
    />
    <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]} />

    <PageHero
      overline="Frequently Asked Questions"
      title="Honest Answers to Common Questions"
      subtitle="Buying a new floor is a big decision. Here are clear, straightforward answers — and Tyler is always happy to answer more by phone."
      image={IMG.hexLed}
    />

    <FaqSection faqs={GENERAL_FAQS} heading="Everything You Want to Know" className="bg-[#0A0A0A]" />

    <FinalCTA heading="Still Have Questions? Call Tyler Directly." />
  </div>
);

export default FAQ;
